"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/CreateNew/Compose/icons.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

// Round 3 stroke icons for New chat and the compose (24px grid). They
// draw in `currentColor`, so the colour comes from the token on the parent.






const makeIcon = (paths) => {
  const StrokeIcon = ({ size = 16, className }) => (
    _react2.default.createElement('svg', {
      className: className,
      width: size,
      height: size,
      viewBox: "0 0 24 24"   ,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1.75",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      'aria-hidden': "true",
      focusable: "false", __self: this, __source: {fileName: _jsxFileName, lineNumber: 13}}

      ,  paths 
    )
  )
  return StrokeIcon
}

 const LockIcon = makeIcon(_react2.default.createElement(_react2.default.Fragment, null
  , _react2.default.createElement('rect', { x: "5", y: "11", width: "14", height: "9", rx: "2", __self: this, __source: {fileName: _jsxFileName, lineNumber: 33}} )
  , _react2.default.createElement('path', { d: "M8 11V8a4 4 0 018 0v3"     , __self: this, __source: {fileName: _jsxFileName, lineNumber: 34}} )
)); exports.LockIcon = LockIcon

 const BubbleIcon = makeIcon(
  _react2.default.createElement('path', { d: "M4 5h16v11H9l-5 4z"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 38}} ),
); exports.BubbleIcon = BubbleIcon

 const PeopleIcon = makeIcon(_react2.default.createElement(_react2.default.Fragment, null
  , _react2.default.createElement('circle', { cx: "9", cy: "8", r: "3.5", __self: this, __source: {fileName: _jsxFileName, lineNumber: 42}} )
  , _react2.default.createElement('path', { d: "M2.5 20c0-3.5 3-5.5 6.5-5.5s6.5 2 6.5 5.5"      , __self: this, __source: {fileName: _jsxFileName, lineNumber: 43}} )
  , _react2.default.createElement('path', { d: "M16 4.5a3.5 3.5 0 010 7M21.5 20c0-2.6-1.6-4.4-4-5.2"      , __self: this, __source: {fileName: _jsxFileName, lineNumber: 44}} )
)); exports.PeopleIcon = PeopleIcon

 const VideoIcon = makeIcon(_react2.default.createElement(_react2.default.Fragment, null
  , _react2.default.createElement('rect', { x: "3", y: "6", width: "13", height: "12", rx: "2", __self: this, __source: {fileName: _jsxFileName, lineNumber: 48}} )
  , _react2.default.createElement('path', { d: "M16 10.5l5-3v9l-5-3z" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 49}} )
)); exports.VideoIcon = VideoIcon

 const UnlockIcon = makeIcon(_react2.default.createElement(_react2.default.Fragment, null
  , _react2.default.createElement('rect', { x: "5", y: "11", width: "14", height: "9", rx: "2", __self: this, __source: {fileName: _jsxFileName, lineNumber: 53}} )
  , _react2.default.createElement('path', { d: "M8 11V8a4 4 0 017.75-1.4"    , __self: this, __source: {fileName: _jsxFileName, lineNumber: 54}} )
)); exports.UnlockIcon = UnlockIcon

 const PersonPlusIcon = makeIcon(_react2.default.createElement(_react2.default.Fragment, null
  , _react2.default.createElement('circle', { cx: "10", cy: "8", r: "3.5", __self: this, __source: {fileName: _jsxFileName, lineNumber: 58}} )
  , _react2.default.createElement('path', { d: "M3.5 20c0-3.5 3-5.5 6.5-5.5 1.3 0 2.5.3 3.5.8M18 14v6M15 17h6"         , __self: this, __source: {fileName: _jsxFileName, lineNumber: 59}} )
)); exports.PersonPlusIcon = PersonPlusIcon

 const ChevronLeftIcon = makeIcon(_react2.default.createElement('path', { d: "M15 5l-7 7 7 7"    , __self: this, __source: {fileName: _jsxFileName, lineNumber: 62}} )); exports.ChevronLeftIcon = ChevronLeftIcon
 const ChevronRightIcon = makeIcon(_react2.default.createElement('path', { d: "M9 5l7 7-7 7"   , __self: this, __source: {fileName: _jsxFileName, lineNumber: 63}} )); exports.ChevronRightIcon = ChevronRightIcon
 const InfoIcon = makeIcon(_react2.default.createElement(_react2.default.Fragment, null
  , _react2.default.createElement('circle', { cx: "12", cy: "12", r: "9", __self: this, __source: {fileName: _jsxFileName, lineNumber: 65}} )
  , _react2.default.createElement('path', { d: "M12 11v5M12 8v.01"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 66}} )
)); exports.InfoIcon = InfoIcon
 const SearchIcon = makeIcon(_react2.default.createElement(_react2.default.Fragment, null
  , _react2.default.createElement('circle', { cx: "11", cy: "11", r: "6.5", __self: this, __source: {fileName: _jsxFileName, lineNumber: 69}} )
  , _react2.default.createElement('path', { d: "M16 16l4 4"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 70}} )
)); exports.SearchIcon = SearchIcon
 const WarnIcon = makeIcon(_react2.default.createElement(_react2.default.Fragment, null
  , _react2.default.createElement('path', { d: "M12 4l9 16H3z"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 73}} )
  , _react2.default.createElement('path', { d: "M12 10v4M12 17v.01"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 74}} )
)); exports.WarnIcon = WarnIcon
 const CheckIcon = makeIcon(_react2.default.createElement('path', { d: "M5 12.5l4.5 4.5L19 7.5"   , __self: this, __source: {fileName: _jsxFileName, lineNumber: 76}} )); exports.CheckIcon = CheckIcon

 const CloseIcon = makeIcon(_react2.default.createElement('path', { d: "M6 6l12 12M18 6L6 18"    , __self: this, __source: {fileName: _jsxFileName, lineNumber: 78}} )); exports.CloseIcon = CloseIcon
 const PlusIcon = makeIcon(_react2.default.createElement('path', { d: "M12 5v14M5 12h14"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 79}} )); exports.PlusIcon = PlusIcon
 const AlertIcon = makeIcon(_react2.default.createElement(_react2.default.Fragment, null
  , _react2.default.createElement('circle', { cx: "12", cy: "12", r: "9", __self: this, __source: {fileName: _jsxFileName, lineNumber: 81}} )
  , _react2.default.createElement('path', { d: "M12 8v5M12 16.5v.01"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 82}} )
)); exports.AlertIcon = AlertIcon
